import { defaultStatus } from '@/_schemas/status-input';

import type { JobPositionFormSchema } from './schemas';

export const defaultValues: Readonly<JobPositionFormSchema> = {
  id: -1,
  name: '',
  salary_grade: null,
  department: null,
  business_discipline: null,
  preferred_relationship: null,
  preferred_location: null,
  status: defaultStatus,
  result_statement: '',
  strategic_work: '',
  tactical_work: '',
  standards_work: '',

  need_to_succeed: '',
  expectations: '',
  position_overview: '',
  applicant_questions: '',
  interview_questions: '',
} as const;
